import * as React from 'react';
import styles from './Deluxe.css';
import { 
  DeluxeContext, 
  DeluxeHeader,
  DeluxeMain,
  DeluxeFooter,
} from '.';

export const DeluxeLayout = () => {
  return (
    <DeluxeContext.Consumer>
      {({ currentSelection}) => {
        const { page } = currentSelection;
        return (        
          <div className={styles['deluxe-wrapper']}>
            <DeluxeHeader />
            <DeluxeMain /> 
            {page === 'features' && <DeluxeFooter />}
          </div>
        ); 
      }}
    </DeluxeContext.Consumer>
  );
};